import React from 'react'
import './App.css';
import Header from './Components/Header/Header';
import Footer from './Components/Footer/Footer';
import Havola from './Components/Havolalar/Havola';
import Home from './Pages/Home/Home';
import Yangiliklar from './Pages/Yangiliklar/Yangiliklar'
import Tuzilma from './Pages/Tuzilma/Tuzilma'
import NotFound from './Pages/Not Found/NotFound';
import Ramz from './Pages/Ramz/Ramz';
import Madaniy from './Pages/Madaniy/Madaniy'
import Media from './Pages/Media/Media'
import Fakultet from './Pages/Fakultet/Fakultet'
import Aloqa from './Pages/Aloqa/Aloqa'
import Bayroq from './Pages/Ramz/Bayroq/Bayroq';
import Gerb from './Pages/Ramz/Gerb/Gerb';
import Madhiya from './Pages/Ramz/Madhiya/Madhiya';
import NewInfo from './Pages/Yangiliklar/NewInfo/NewInfo';
import Video from './Pages/Media/Video/Video';
import Photo from './Pages/Media/Photo/Photo'
import Teacher from './Pages/Tuzilma/Teacher/Teacher';
import {BrowserRouter as Router,Routes,Route} from 'react-router-dom'

function App() {
  return (<Router>
    <div className="App">
      <Header/>
   
      
        <Routes className="routes">
          <Route path='/' exact element={<Home/>}/>
          <Route path="yangiliklar" element={<Yangiliklar/>}/>
          <Route path="tuzilma" element={<Tuzilma/>}/>
          <Route path='/teacher/:id' element={<Teacher/>}/>
          <Route path="aloqa" element={<Aloqa/>}/>
          <Route path="madaniy" element={<Madaniy/>}/>
          <Route path='media'  element={<Media/>}>
            <Route path='video' exact element={<Video/>}/>
            <Route path='photo' element={<Photo/>}/>
          </Route>
          <Route path="fakultet" element={<Fakultet/>}/>
          <Route path="*" element={<NotFound/>}/>
          <Route path="ramz" element={<Ramz/>} >
           <Route path="bayroq" element={<Bayroq/>}/>
           <Route path="gerb" element={<Gerb/>}/>
           <Route path="madhiya" element={<Madhiya/>}/>
          </Route>
          <Route  path="/newinfo/:id" element={<NewInfo/>}/>

        </Routes>
     
      
      <Havola/>
      <Footer/>
    </div> </Router>
  );
}

export default App;
